let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5XnIl")).then(() => parcelRequire('a1RiA'));